import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const ProductCard = ({ product, index = 0 }) => {
  return (
    <Link
      to={`/produk/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block bg-white rounded-2xl border border-[rgba(28,28,28,0.08)] overflow-hidden hover:shadow-[0_18px_50px_rgba(28,28,28,0.10)] transition-all duration-500"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#F4F1EA]">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        {product.badge && (
          <span
            className="absolute top-4 left-4 inline-flex items-center px-3 py-1 rounded-full bg-[#1C1C1C] text-[#FAF9F6] text-[10px] font-bold tracking-[0.18em] uppercase"
            data-testid={`product-badge-${product.id}`}
          >
            {product.badge}
          </span>
        )}
        <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-[#FAF9F6] flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">
          <ArrowUpRight className="w-4 h-4 text-[#1C1C1C]" />
        </div>
      </div>

      <div className="p-5">
        <div className="label-eyebrow text-[#E07A5F]">{product.category.replace("-", " ")}</div>
        <h3 className="font-heading font-semibold text-lg mt-2 text-[#1C1C1C] group-hover:text-[#E07A5F] transition-colors leading-snug">
          {product.name}
        </h3>
        <p className="text-sm text-[#4A4A4A] mt-2 line-clamp-2 leading-relaxed">
          {product.short_description}
        </p>
        <div className="mt-4 flex items-end justify-between">
          <div className="flex items-baseline gap-2">
            <span className="font-heading font-bold text-xl text-[#E07A5F]">
              RM {product.price.toLocaleString("ms-MY", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
            </span>
          </div>
          <span className="text-[11px] font-semibold text-[#81B29A]">Tempahan Khas</span>
        </div>

        <span
          className="mt-4 w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-[#1C1C1C] text-[#FAF9F6] group-hover:bg-[#E07A5F] transition-all duration-300 font-semibold text-xs tracking-wider uppercase"
          data-testid={`view-product-btn-${product.id}`}
        >
          Lihat Produk
          <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
        </span>
      </div>
    </Link>
  );
};
